const ANNOTATION_KEY = 'geniussports.com/cost-history';

export interface CostHistoryData {
  [month: string]: { [costType: string]: number };
}

export function parseCostHistory(
  annotations: Record<string, string> | undefined,
): CostHistoryData | null {
  const raw = annotations?.[ANNOTATION_KEY];
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return null;
    return parsed as CostHistoryData;
  } catch {
    return null;
  }
}

export function hasCostHistory(
  annotations: Record<string, string> | undefined,
): boolean {
  return parseCostHistory(annotations) !== null;
}

export function totalForMonth(costs: { [costType: string]: number }): number {
  return Object.values(costs).reduce((sum, v) => sum + v, 0);
}

export function latestMonth(data: CostHistoryData): string | null {
  const months = Object.keys(data).sort();
  return months.length > 0 ? months[months.length - 1] : null;
}

export function allCostTypes(data: CostHistoryData): string[] {
  const types = new Set<string>();
  for (const costs of Object.values(data)) {
    for (const key of Object.keys(costs)) {
      types.add(key);
    }
  }
  return Array.from(types).sort();
}

export function formatUsd(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
